import { Button } from '@design-system';
import { Loader2, RefreshCw } from 'lucide-react';

interface LoadingBlockProps {
  label?: string;
  className?: string;
}

export function LoadingBlock({
  label = 'Loading…',
  className = 'py-16',
}: LoadingBlockProps) {
  return (
    <div
      className={`flex items-center justify-center gap-2 text-sm text-gray-600 ${className}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="text-primary h-5 w-5 animate-spin" />
      <span>{label}</span>
    </div>
  );
}

interface RefreshButtonProps {
  onClick: () => void;
  isFetching: boolean;
  disabled?: boolean;
  label?: string;
}

export function RefreshButton({
  onClick,
  isFetching,
  disabled,
  label = 'Refresh',
}: RefreshButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={disabled || isFetching}
      aria-label={label}
      title={label}
    >
      <RefreshCw className={`mr-1 h-4 w-4 ${isFetching ? 'animate-spin' : ''}`} />
      {isFetching ? 'Refreshing…' : label}
    </Button>
  );
}
